import React from 'react';
// Components
// import OnboardingSteps from './Steps/index';
import AuthHeader from "../../components/AuthHeader";
import WhiteLogo from "../../assets/images/logo.svg";


// Styles
import "./OnBoarding.css"

const Onboarding = ({ children }) => {




  

  return (
    <div className="onboarding-container zl-pass-main">
        <AuthHeader bgColor="#3D81FF" color="#fff" logo={WhiteLogo} isSharePage={false} />

        <div className="onboarding-middle-container">
          {children}
        </div>
    </div>
  );
};

export default Onboarding;